import { useEffect } from "react";
import { Link } from "wouter";
import { LockIcon, PhoneIcon } from "lucide-react";
import "./orderTheme.css";

/*
 * Shared chrome for the public order flow. The app already loads Inter
 * 300-700 globally (client/index.html); the order pages also need Inter 800
 * (eyebrows, primary CTA) and Fraunces 500 (page headings), loaded here only
 * when an order page mounts, with display=swap. The server CSP already allows
 * fonts.googleapis.com / fonts.gstatic.com.
 */
const FONT_LINK_ID = "lp-order-fonts";
const FONT_HREF =
  "https://fonts.googleapis.com/css2?family=Inter:wght@800&family=Fraunces:opsz,wght@9..144,500&display=swap";

export function useOrderFonts() {
  useEffect(() => {
    if (typeof document === "undefined" || document.getElementById(FONT_LINK_ID)) return;
    const link = document.createElement("link");
    link.id = FONT_LINK_ID;
    link.rel = "stylesheet";
    link.href = FONT_HREF;
    document.head.appendChild(link);
  }, []);
}

export function OrderHeader({ right }: { right?: React.ReactNode }) {
  return (
    <header className="lp-header">
      <div className="lp-container lp-header-row">
        <Link href="/" className="lp-logo" aria-label="LimePhone home">
          <span className="lp-logo-mark" aria-hidden>
            <PhoneIcon className="w-4 h-4" />
          </span>
          LimePhone
        </Link>
        {right ?? (
          <span className="lp-secure">
            <LockIcon className="w-3.5 h-3.5" aria-hidden />
            Secure checkout
          </span>
        )}
      </div>
    </header>
  );
}
